import React, { useState, useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { PropTypes } from 'prop-types';
var PnmacMicrophone = function (_a) {
  var speechEnded = _a.speechEnded,
    imageForOn = _a.imageForOn,
    imageForOff = _a.imageForOff,
    pennyCanHear = _a.pennyCanHear,
    handleMicOnEvent = _a.handleMicOnEvent,
    onStateChange = _a.onStateChange;
  var _b = useSpeechRecognition(),
    listening = _b.listening,
    browserSupportsSpeechRecognition = _b.browserSupportsSpeechRecognition;
  var _c = useState(listening),
    isListening = _c[0],
    setIsListening = _c[1];
  useEffect(function () {
    // console.log(`islistening: ${listening}`)
    if (onStateChange) {
      onStateChange(listening);
    }
    //setIsListening(listening);
  }, [listening]);
  if (!browserSupportsSpeechRecognition) {
    console.error("Browser doesn't support speech recognition.");
    return /*#__PURE__*/React.createElement("span", null);
  }
  SpeechRecognition.getRecognitionManager().recognition.onresult = function (evt) {
    var result = "";
    if (evt.results && evt.results.length > 0) {
      if (evt.results[0].isFinal) {
        result = evt.results[0][0].transcript;
        speechEnded([{
          _id: Math.round(Math.random() * 1000000),
          text: result,
          user: {
            _id: 1
          },
          createdAt: new Date()
        }]);
      }
    }
  };
  var handleOnClick = function () {
    console.log(listening);
    if (handleMicOnEvent) handleMicOnEvent(listening);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: browserSupportsSpeechRecognition ? "flex" : "none",
      alignItems: "center",
      justifyContent: "center",
      flexGrow: 0,
      cursor: "pointer",
      paddingLeft: "10px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      cursor: "pointer"
    },
    alt: 'Microphone',
    onClick: handleOnClick,
    src: pennyCanHear ? imageForOn : imageForOff
  }));
};
PnmacMicrophone.propTypes = {
  speechEnded: PropTypes.func
};
export default PnmacMicrophone;